import { Link } from "react-router-dom";
import "./historique.css"
import SideBareMagasin from "../SideBareMagasin/SideBareMagasin";
import { useContext, useEffect, useState } from "react";
import { MagasinContext } from "../../../Context/MagasinContext";
import { Commande, CommandeMagasin } from "../../../Modeles/Commande";
import HistoriqueMagasinService from "../../../Services/Magasin/HistoriqueMagasinService";
import HistoriqueCommande from "../../../Services/Admin/HistoriqueCommande";
import { Filter, X, Plus, Eye, Calendar, DollarSign, Store, Package, ChevronRight, MapPin } from 'lucide-react';
import { NewSideBarMagasins } from "../../NewSidebarMagasin";
import { formatCodeCommande } from "../../../Services/CodeTrackingHelper";

export interface commandeType{
  product : CommandeMagasin[],
  messageErros:string,
}

// Enhanced Mobile Filter Component with Modern Design
const MobileOrderFilter = ({
  statutFilter,
  typeFilter,
  onStatutChange,
  onTypeChange,
  orderCount
}: {
  statutFilter: string;
  typeFilter: string;
  onStatutChange: (status: string) => void;
  onTypeChange: (type: string) => void;
  orderCount: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const statusOptions = [
    { value: '', label: 'Tous les statuts', icon: '○', gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
    { value: 'confirmé', label: 'Confirmé', icon: '✓', gradient: 'linear-gradient(135deg, #0ba360 0%, #3cba92 100%)' },
    { value: 'en cours..', label: 'En cours', icon: '◐', gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' },
    { value: 'annuler', label: 'Annulé', icon: '✕', gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' }
  ];

  const typeOptions = [
    { value: '', label: 'Tout', icon: '◈' },
    { value: 'recu', label: 'Reçues', icon: '↓' },
    { value: 'demandé', label: 'Demandées', icon: '↑' }
  ];

  const activeFiltersCount = (statutFilter ? 1 : 0) + (typeFilter ? 1 : 0);

  const clearAllFilters = () => {
    onStatutChange('');
    onTypeChange('');
  };

  return (
    <>
      {/* Filter Toggle Bar */}
      <div style={{
        position: 'sticky',
        top: 0,
        background: 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.95) 100%)',
        backdropFilter: 'blur(20px)',
        zIndex: 50,
        padding: '1.25rem 1rem',
        borderBottom: '1px solid rgba(0,0,0,0.06)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.03)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.75rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flex: 1 }}>
            <button
              onClick={() => setIsOpen(!isOpen)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem',
                padding: '0.75rem 1.25rem',
                background: activeFiltersCount > 0 
                  ? 'linear-gradient(135deg, #FFC400 0%, #FFD700 100%)' 
                  : 'white',
                color: activeFiltersCount > 0 ? 'white' : '#1a1a1a',
                border: activeFiltersCount > 0 ? 'none' : '1.5px solid #e8e8e8',
                borderRadius: '14px',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                fontSize: '0.9375rem',
                fontWeight: '600',
                boxShadow: activeFiltersCount > 0 
                  ? '0 4px 16px rgba(255, 196, 0, 0.3)' 
                  : '0 2px 8px rgba(0,0,0,0.04)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = activeFiltersCount > 0 
                  ? '0 6px 20px rgba(255, 196, 0, 0.4)' 
                  : '0 4px 12px rgba(0,0,0,0.08)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = activeFiltersCount > 0 
                  ? '0 4px 16px rgba(255, 196, 0, 0.3)' 
                  : '0 2px 8px rgba(0,0,0,0.04)';
              }}
            >
              <Filter size={18} strokeWidth={2.5} />
              <span>Filtres</span>
              {activeFiltersCount > 0 && (
                <span style={{
                  backgroundColor: 'rgba(255,255,255,0.3)',
                  color: 'white',
                  fontSize: '0.75rem',
                  fontWeight: '700',
                  padding: '0.25rem 0.5rem',
                  borderRadius: '8px',
                  minWidth: '20px',
                  textAlign: 'center'
                }}>
                  {activeFiltersCount}
                </span>
              )}
            </button>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.5rem 0.875rem',
              backgroundColor: '#f8f9fa',
              borderRadius: '12px'
            }}>
              <Package size={16} color="#6b7280" strokeWidth={2} />
              <span style={{ 
                fontSize: '0.875rem', 
                fontWeight: '600',
                color: '#374151'
              }}>
                {orderCount}
              </span>
            </div>
          </div>
          
          {activeFiltersCount > 0 && (
            <button
              onClick={clearAllFilters}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '38px',
                height: '38px',
                backgroundColor: '#fee2e2',
                color: '#dc2626',
                border: 'none',
                borderRadius: '12px',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#fecaca';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#fee2e2';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <X size={18} strokeWidth={2.5} />
            </button>
          )}
        </div>
      </div>

      {/* Enhanced Filter Panel */}
      {isOpen && (
        <div style={{
          background: 'white',
          borderBottom: '1px solid rgba(0,0,0,0.06)',
          animation: 'slideDown 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.06)'
        }}>
          <div style={{ padding: '1.5rem 1rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <h3 style={{ 
                fontWeight: '700', 
                fontSize: '1.125rem',
                margin: 0,
                background: 'linear-gradient(135deg, #1a1a1a 0%, #4a4a4a 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Filtrer les commandes
              </h3>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  padding: '0.5rem',
                  background: '#f3f4f6',
                  border: 'none',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#e5e7eb';
                  e.currentTarget.style.transform = 'rotate(90deg)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3f4f6';
                  e.currentTarget.style.transform = 'rotate(0deg)';
                }}
              >
                <X size={18} strokeWidth={2.5} />
              </button>
            </div>

            {/* Type Filter */}
            <div>
              <label style={{ 
                fontSize: '0.8125rem', 
                fontWeight: '600', 
                display: 'block', 
                marginBottom: '0.75rem',
                color: '#4b5563',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                Type de commande
              </label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.625rem' }}>
                {typeOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => onTypeChange(option.value)}
                    style={{
                      padding: '0.875rem 0.75rem',
                      borderRadius: '12px',
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      border: typeFilter === option.value ? '2px solid #FFC400' : '1.5px solid #e8e8e8',
                      background: typeFilter === option.value 
                        ? 'linear-gradient(135deg, rgba(255,196,0,0.1) 0%, rgba(255,215,0,0.1) 100%)'
                        : 'white',
                      color: typeFilter === option.value ? '#1a1a1a' : '#6b7280',
                      cursor: 'pointer',
                      transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '0.375rem'
                    }}
                    onMouseOver={(e) => {
                      if (typeFilter !== option.value) {
                        e.currentTarget.style.borderColor = '#d1d5db';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (typeFilter !== option.value) {
                        e.currentTarget.style.borderColor = '#e8e8e8';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }
                    }}
                  >
                    <span style={{ fontSize: '1.25rem' }}>{option.icon}</span>
                    <span style={{ fontSize: '0.8125rem' }}>{option.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Status Filter */}
            <div>
              <label style={{ 
                fontSize: '0.8125rem', 
                fontWeight: '600', 
                display: 'block', 
                marginBottom: '0.75rem',
                color: '#4b5563',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                Statut
              </label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
                {statusOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => onStatutChange(option.value)}
                    style={{
                      padding: '1rem',
                      borderRadius: '14px',
                      fontSize: '0.9375rem',
                      fontWeight: '600',
                      border: statutFilter === option.value ? 'none' : '1.5px solid #e8e8e8',
                      background: statutFilter === option.value ? option.gradient : 'white',
                      color: statutFilter === option.value ? 'white' : '#374151',
                      cursor: 'pointer',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      boxShadow: statutFilter === option.value 
                        ? '0 4px 16px rgba(0,0,0,0.15)' 
                        : '0 2px 6px rgba(0,0,0,0.04)'
                    }}
                    onMouseOver={(e) => {
                      if (statutFilter !== option.value) {
                        e.currentTarget.style.transform = 'translateX(4px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (statutFilter !== option.value) {
                        e.currentTarget.style.transform = 'translateX(0)';
                        e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.04)';
                      }
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <span style={{ 
                        fontSize: '1.25rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '32px',
                        height: '32px',
                        borderRadius: '8px',
                        background: statutFilter === option.value 
                          ? 'rgba(255,255,255,0.25)' 
                          : '#f3f4f6'
                      }}>
                        {option.icon}
                      </span>
                      <span>{option.label}</span>
                    </div>
                    {statutFilter === option.value && (
                      <ChevronRight size={20} strokeWidth={2.5} />
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* Apply Button */}
            <button
              onClick={() => setIsOpen(false)}
              style={{
                width: '100%',
                padding: '1rem',
                background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
                color: 'white',
                borderRadius: '14px',
                fontWeight: '700',
                fontSize: '0.9375rem',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.2)';
              }}
            >
              Appliquer les filtres
            </button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};

// Modern Order Card Component
const OrderCard = ({ item, MagasinId }: { item: CommandeMagasin, MagasinId: string }) => {
  const getStatusConfig = (status: string) => {
    switch (status.toLowerCase()) {
      case 'confirmé':
        return {
          gradient: 'linear-gradient(135deg, #0ba360 0%, #3cba92 100%)',
          color: '#065f46',
          icon: '✓',
          bgColor: 'rgba(11, 163, 96, 0.1)'
        };
      case 'annuler':
        return {
          gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
          color: '#991b1b',
          icon: '✕',
          bgColor: 'rgba(250, 112, 154, 0.1)'
        };
      default:
        return {
          gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          color: '#92400e',
          icon: '◐',
          bgColor: 'rgba(240, 147, 251, 0.1)'
        };
    }
  };

  const statusConfig = getStatusConfig(item.Statut);

  return (
    <div style={{
      background: 'white',
      border: '1.5px solid rgba(0,0,0,0.06)',
      borderRadius: '20px',
      padding: '1.25rem',
      boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      overflow: 'hidden'
    }}
    onMouseOver={(e) => {
      e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.12)';
      e.currentTarget.style.transform = 'translateY(-4px)';
      e.currentTarget.style.borderColor = 'rgba(255,196,0,0.3)';
    }}
    onMouseOut={(e) => {
      e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.04)';
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.borderColor = 'rgba(0,0,0,0.06)';
    }}
    >
      {/* Decorative Element */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '120px',
        height: '120px',
        background: statusConfig.gradient,
        opacity: 0.05,
        borderRadius: '0 20px 0 100%',
        pointerEvents: 'none'
      }} />

      {/* Header */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        marginBottom: '1rem',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          padding: '0.5rem 0.875rem',
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
          borderRadius: '12px',
          border: '1px solid rgba(0,0,0,0.04)'
        }}>
          <span style={{ 
            fontSize: '0.6875rem',
            fontWeight: '700',
            color: '#6b7280',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            ID
          </span>
          <span style={{
            fontSize: '0.8125rem',
            fontFamily: 'SF Mono, Monaco, Consolas, monospace',
            fontWeight: '700',
            color: '#1a1a1a'
          }}>
            {formatCodeCommande(item.RefCommande, item.IdCommande, item.DateCommande)}
          </span>
        </div>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          padding: '0.5rem 0.875rem',
          borderRadius: '12px',
          background: statusConfig.bgColor,
          border: `1.5px solid ${statusConfig.color}20`
        }}>
          <span style={{ 
            fontSize: '1rem',
            lineHeight: 1
          }}>
            {statusConfig.icon}
          </span>
          <span style={{ 
            fontSize: '0.8125rem', 
            fontWeight: '700',
            color: statusConfig.color,
            textTransform: 'capitalize'
          }}>
            {item.Statut}
          </span>
        </div>
      </div>

      {/* Content */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', position: 'relative', zIndex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div style={{
            width: '48px',
            height: '48px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
          }}>
            <Store size={22} color="white" strokeWidth={2.5} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ 
              fontSize: '0.9375rem', 
              fontWeight: '700', 
              margin: 0, 
              overflow: 'hidden', 
              textOverflow: 'ellipsis', 
              whiteSpace: 'nowrap',
              color: '#1a1a1a',
              marginBottom: '0.25rem'
            }}>
              {item.NomClient}
            </p>
            <p style={{ 
              fontSize: '0.75rem', 
              color: item.TypeUtilisateur === 'commercial' ? '#4f46e5' : item.TypeUtilisateur === 'client' ? '#059669' : '#6b7280', 
              margin: 0,
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              {item.TypeUtilisateur ? item.TypeUtilisateur : 'Magasin'}
            </p>
          </div>
        </div>

<div style={{
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '0.75rem',
  padding: '1rem',
  background: 'linear-gradient(135deg, #f8f9fa 0%, #f1f3f5 100%)',
  borderRadius: '14px',
  border: '1px solid rgba(0,0,0,0.04)'
}}>
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
      <DollarSign size={14} color="#FFC400" strokeWidth={2.5} />
      <span style={{ 
        fontSize: '0.6875rem',
        color: '#6b7280',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        Montant
      </span>
    </div>
    <p style={{ 
      fontSize: '1.125rem', 
      fontWeight: '800', 
      margin: 0,
      color: '#1a1a1a',
      lineHeight: 1
    }}>
      {item.TotalCommandeHT}
      <span style={{ 
        fontSize: '0.75rem', 
        fontWeight: '600',
        color: '#6b7280',
        marginLeft: '0.25rem'
      }}>
        MAD
      </span>
    </p>
  </div>

  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
      <Calendar size={14} color="#667eea" strokeWidth={2.5} />
      <span style={{ 
        fontSize: '0.6875rem',
        color: '#6b7280',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        Date
      </span>
    </div>
    <p style={{ 
      fontSize: '0.8125rem', 
      fontWeight: '700', 
      margin: 0,
      color: '#374151',
      lineHeight: 1.3
    }}>
      {item.DateCommande}
    </p>
  </div>

  {/* Full-width address row */}
  <div style={{ 
    gridColumn: '1 / -1',
    display: 'flex', 
    flexDirection: 'column', 
    gap: '0.375rem',
    paddingTop: '0.375rem',
    borderTop: '1px solid rgba(0,0,0,0.06)'
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
      <MapPin size={14} color="#10b981" strokeWidth={2.5} />
      <span style={{ 
        fontSize: '0.6875rem',
        color: '#6b7280',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        Adresse
      </span>
    </div>
    <p style={{ 
      fontSize: '0.8125rem', 
      fontWeight: '700', 
      margin: 0,
      color: '#374151',
      lineHeight: 1.3
    }}>
      {item.Adresse}
    </p>
  </div>
</div>
      </div>

      {/* Action */}
      <div style={{ marginTop: '1.25rem', paddingTop: '1rem', borderTop: '1.5px solid rgba(0,0,0,0.06)' }}>
        <Link
          to={`/magasins/${MagasinId}/historiques/${item.IdCommande}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.625rem',
            width: '100%',
            padding: '0.875rem 1.25rem',
            background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
            color: 'white',
            borderRadius: '14px',
            fontWeight: '700',
            fontSize: '0.9375rem',
            textDecoration: 'none',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
            position: 'relative',
            overflow: 'hidden'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
          }}
        >
          <Eye size={18} strokeWidth={2.5} />
          <span>Voir détails</span>
          <ChevronRight size={18} strokeWidth={2.5} />
        </Link>
      </div>
            <div style={{ marginTop: '0.1rem', paddingTop: '1rem', borderTop: '1.5px solid rgba(0,0,0,0.06)' }}>
        <Link
          to={`/magasins/${MagasinId}/deplace/commande/${item.IdCommande}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.625rem',
            width: '100%',
            padding: '0.875rem 1.25rem',
            background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
            color: 'white',
            borderRadius: '14px',
            fontWeight: '700',
            fontSize: '0.9375rem',
            textDecoration: 'none',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
            position: 'relative',
            overflow: 'hidden'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
          }}
        >
          <i className="bi bi-arrow-repeat"></i>
          <span>Déplacez</span>
          <ChevronRight size={18} strokeWidth={2.5} />
        </Link>
      </div>
    </div>
  );
};

export default function HistoriqueMagasin(){
   const [loading, setLoading] = useState<boolean>(true);
   const itemsPerPage = 10;
   const [currentPage, setCurrentPage] = useState(1);
   const [statusFilter, setStatusFilter] = useState("");
   const [searchTerm, setSearchTerm] = useState("");
   const magasinContext = useContext(MagasinContext);
   const MagasinId = localStorage.getItem('MagasinId');
   const MagasinName = localStorage.getItem('MagasinName');
console.log('magasinname',MagasinName);
    const id = MagasinId || magasinContext.id?.id;
    
    const [state , setState] = useState<commandeType>({
      product:[] as CommandeMagasin[],
      messageErros : "accune commande",
  
  })
  const [stateMagasin , setStateMagasin] = useState<commandeType>({
    
    product:[] as CommandeMagasin[],
    messageErros : "accune produit",
  
  })
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setStatusFilter(e.target.value);
  };
  const handleChangePage = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };
useEffect(() => {
  setLoading(true);
  HistoriqueCommande()
    .getCommande()
    .then((res) => {
      const data = Array.isArray(res.data) ? res.data : [];
      setState({
        product: data,
        messageErros: data.length === 0 ? "Aucune commande" : "",
      });
      setLoading(false);
    })
    .catch((err) => {
      console.error("Error fetching commandes:", err);
      setState({
        product: [],
        messageErros: "Aucune commande trouvée",
      });
      setLoading(false);
    });
}, []);

const { product = [], messageErros } = state;
console.log("product", product);

const filteredProducts = Array.isArray(product) ? product : [];
console.log("filteredProducts ", filteredProducts);
const [statutFilter, setStatutFilter] = useState("");
const [typeFilter, setTypeFilter] = useState("");
const filteredCommandes = filteredProducts.filter((commande) => {
  const nomClient = commande.NomClient?.toLowerCase() || "";
  const nomMagasin = MagasinName?.toLowerCase() || "";
  const statut = commande.Statut?.toLowerCase() || "";
  const commandeId = String(commande.IdCommande ?? "").toLowerCase();
  const refCommande = (commande.RefCommande ?? "").toLowerCase();
  const formattedCode = formatCodeCommande(commande.RefCommande, commande.IdCommande, commande.DateCommande).toLowerCase();
  const adresse = (commande.Adresse ?? "").toLowerCase();
  const search = searchTerm.trim().toLowerCase();
  const userType = (commande.TypeUtilisateur || "").toLowerCase();

  const isDemandeByUs = nomClient === nomMagasin || userType === "commercial" || userType === "client" || userType === "commercials" || userType === "clients";

  // Filter by type (reçu / demandé)
  if (typeFilter === "recu" && isDemandeByUs && (commande.NomMagasin || "").toLowerCase() !== nomMagasin) return false;
  if (typeFilter === "demandé" && !isDemandeByUs) return false;

  // Filter by statut (confirmé, encours, annuler)
  if (statutFilter && statut !== statutFilter.toLowerCase() && !statut.includes(statutFilter.toLowerCase())) return false;

  // Search filter
  if (
    search &&
    !nomClient.includes(search) &&
    !commandeId.includes(search) &&
    !refCommande.includes(search) &&
    !formattedCode.includes(search) &&
    !adresse.includes(search) &&
    !(commande.NomMagasin || "").toLowerCase().includes(search) &&
    !userType.includes(search)
  ) {
    return false;
  }

  return true; // Keep if it passed filters
});


  useEffect(() => {
    // Global responsive/sidebar layout now handles page sizing.
  }, []);
  // Pagination calculation
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCommandes.slice(indexOfFirstItem, indexOfLastItem);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredCommandes.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  if (screenWidth <= 768){
    return(
      <>
        <NewSideBarMagasins/>
        
        <div style={{ 
          minHeight: '100vh', 
          background: 'linear-gradient(180deg, #fafbfc 0%, #f3f4f6 100%)'
        }}>
          {/* Modern Header */}
          <div style={{ 
            background: 'white',
            borderBottom: '1.5px solid rgba(0,0,0,0.06)', 
            padding: '1.25rem 1rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.03)'
          }}>
            <Link 
              to={`/magasins/${id}/commande`} 
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.625rem',
                padding: '0.875rem 1.5rem',
                background: 'linear-gradient(135deg, #FFC400 0%, #FFD700 100%)',
                color: 'white',
                borderRadius: '14px',
                fontWeight: '700',
                fontSize: '0.9375rem',
                textDecoration: 'none',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                boxShadow: '0 4px 16px rgba(255, 196, 0, 0.3)',
                border: 'none'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(255, 196, 0, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(255, 196, 0, 0.3)';
              }}
            >
              <Plus size={20} strokeWidth={2.5} />
              <span>Nouvelle commande</span>
            </Link>
          </div>

          {/* Filter Component */}
          <MobileOrderFilter
            statutFilter={statutFilter}
            typeFilter={typeFilter}
            onStatutChange={setStatutFilter}
            onTypeChange={setTypeFilter}
            orderCount={filteredCommandes.length}
          />

          {/* Content */}
          <div style={{ padding: '1.25rem 1rem' }}>
            {loading ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '4rem 0',
                gap: '1.5rem'
              }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  border: '4px solid #f3f4f6',
                  borderTop: '4px solid #FFC400',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }} />
                <span style={{
                  fontSize: '0.9375rem',
                  fontWeight: '600',
                  color: '#6b7280'
                }}>
                  Chargement des commandes...
                </span>
                <style>{`
                  @keyframes spin {
                    to { transform: rotate(360deg); }
                  }
                `}</style>
              </div>
            ) : (
              <>
                {currentItems.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {currentItems.map((item, index) => (
                      <OrderCard key={index} item={item} MagasinId={MagasinId || ''} />
                    ))}
                  </div>
                ) : (
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    padding: '4rem 1rem',
                    background: 'white',
                    borderRadius: '20px',
                    border: '1.5px solid rgba(0,0,0,0.06)'
                  }}>
                    <div style={{
                      width: '80px',
                      height: '80px',
                      background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
                      borderRadius: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '1.5rem'
                    }}>
                      <Package size={40} color="#9ca3af" strokeWidth={2} />
                    </div>
                    <h3 style={{ 
                      fontSize: '1.25rem', 
                      fontWeight: '800', 
                      marginBottom: '0.75rem', 
                      textAlign: 'center',
                      color: '#1a1a1a'
                    }}>
                      Aucune commande trouvée
                    </h3>
                    <p style={{ 
                      color: '#6b7280', 
                      textAlign: 'center', 
                      maxWidth: '20rem', 
                      margin: 0,
                      fontSize: '0.9375rem',
                      lineHeight: 1.6
                    }}>
                      {messageErros}
                    </p>
                  </div>
                )}

                {/* Modern Pagination */}
                {pageNumbers.length > 1 && (
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '0.5rem', 
                    marginTop: '2rem',
                    flexWrap: 'wrap'
                  }}>
                    {pageNumbers.map((number) => (
                      <button
                        key={number}
                        onClick={() => setCurrentPage(number)}
                        style={{
                          minWidth: '44px',
                          height: '44px',
                          padding: '0 0.75rem',
                          borderRadius: '12px',
                          fontSize: '0.9375rem',
                          fontWeight: '700',
                          border: currentPage === number ? 'none' : '1.5px solid #e8e8e8',
                          cursor: 'pointer',
                          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                          background: currentPage === number 
                            ? 'linear-gradient(135deg, #FFC400 0%, #FFD700 100%)' 
                            : 'white',
                          color: currentPage === number ? 'white' : '#374151',
                          boxShadow: currentPage === number 
                            ? '0 4px 12px rgba(255, 196, 0, 0.3)' 
                            : '0 2px 6px rgba(0,0,0,0.04)'
                        }}
                        onMouseOver={(e) => {
                          if (currentPage !== number) {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                          }
                        }}
                        onMouseOut={(e) => {
                          if (currentPage !== number) {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.04)';
                          }
                        }}
                      >
                        {number}
                      </button>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <NewSideBarMagasins />
      <div className="hm-desk-root">

        {/* ── Header ── */}
        <div className="hm-desk-header">
          <div className="hm-desk-header-left">
            <div className="hm-desk-header-icon">
              <Package size={32} strokeWidth={2} />
            </div>
            <div>
              <h1 className="hm-desk-title">Historique des commandes</h1>
              <p className="hm-desk-subtitle">Suivez toutes vos commandes passées et reçues</p>
            </div>
          </div>
          <Link to={`/magasins/${id}/commande`} className="hm-desk-new-btn">
            <Plus size={18} />
            Nouvelle commande
          </Link>
        </div>

        {/* ── KPI Cards ── */}
        <div className="hm-desk-kpis">
          {[
            { label: 'Total commandes', value: filteredCommandes.length, icon: <Package size={20} />, cls: 'kpi-total' },
            { label: 'Confirmées', value: filteredCommandes.filter(c => c.Statut?.toLowerCase() === 'confirmé').length, icon: <Eye size={20} />, cls: 'kpi-confirmed' },
            { label: 'En cours', value: filteredCommandes.filter(c => (c.Statut?.toLowerCase() || '').includes('cours')).length, icon: <Calendar size={20} />, cls: 'kpi-pending' },
            { label: 'Annulées', value: filteredCommandes.filter(c => (c.Statut?.toLowerCase() || '').includes('annul')).length, icon: <X size={20} />, cls: 'kpi-cancelled' },
          ].map((k, i) => (
            <div key={i} className={`hm-desk-kpi-card ${k.cls}`}>
              <div className="hm-desk-kpi-icon">{k.icon}</div>
              <div>
                <span className="hm-desk-kpi-value">{loading ? '—' : k.value}</span>
                <span className="hm-desk-kpi-label">{k.label}</span>
              </div>
            </div>
          ))}
        </div>

        {/* ── Toolbar ── */}
        <div className="hm-desk-toolbar">
          <div className="hm-desk-search-wrap">
            <Filter size={15} className="hm-desk-search-ico" />
            <input
              type="text"
              placeholder="Rechercher: N°, client, adresse…"
              value={searchTerm}
              onChange={handleSearchChange}
              className="hm-desk-search-input"
            />
          </div>
          <div className="hm-desk-toolbar-right">
            <select className="hm-desk-select" onChange={(e) => setStatutFilter(e.target.value)} value={statutFilter}>
              <option value="">Tous les statuts</option>
              <option value="confirmé">Confirmé</option>
              <option value="en cours..">En cours</option>
              <option value="annulé">Annulé</option>
            </select>
            <select className="hm-desk-select" onChange={(e) => setTypeFilter(e.target.value)} value={typeFilter}>
              <option value="">Tous types</option>
              <option value="recu">Reçues</option>
              <option value="demandé">Demandées</option>
            </select>
          </div>
        </div>

        {/* ── Table ── */}
        <div className="hm-desk-table-wrap">
          <table className="hm-desk-table">
            <thead>
              <tr>
                <th>N° Commande</th>
                <th>Client</th>
                <th>Statut</th>
                <th>Adresse</th>
                <th>Mag. intermédiaire</th>
                <th>Adr. intermédiaire</th>
                <th>Livraison</th>
                <th>Frais liv.</th>
                <th>Montant TTC</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 5 }).map((_, i) => (
                  <tr key={i} className="hm-desk-skeleton-row">
                    {Array.from({ length: 11 }).map((_, j) => (
                      <td key={j}><div className="hm-desk-skeleton-cell" /></td>
                    ))}
                  </tr>
                ))
              ) : currentItems.length > 0 ? (
                currentItems.map((item, index) => {
                  const statut = (item.Statut || '').toLowerCase();
                  const isConfirmed = statut === 'confirmé';
                  const isCancelled = statut.includes('annul');
                  const statusCls = isConfirmed ? 'badge-confirmed' : isCancelled ? 'badge-cancelled' : 'badge-pending';
                  const statusLabel = isConfirmed ? 'Confirmé' : isCancelled ? 'Annulé' : item.Statut || 'En cours';
                  return (
                    <tr key={index} className="hm-desk-row">
                      <td><span className="hm-desk-id" style={{ fontFamily: "monospace" }}>{formatCodeCommande(item.RefCommande, item.IdCommande, item.DateCommande)}</span></td>
                      <td>
                        <span className="hm-desk-client">{item.NomClient}</span>
                        {item.TypeUtilisateur && item.TypeUtilisateur !== 'magasin' && item.TypeUtilisateur !== 'magasins' && (
                          <span style={{
                            fontSize: '0.72rem',
                            fontWeight: '600',
                            padding: '2px 7px',
                            borderRadius: '6px',
                            marginLeft: '6px',
                            backgroundColor: item.TypeUtilisateur.toLowerCase().includes('commercial') ? '#e0e7ff' : '#dcfce7',
                            color: item.TypeUtilisateur.toLowerCase().includes('commercial') ? '#3730a3' : '#166534',
                            textTransform: 'capitalize',
                            display: 'inline-block'
                          }}>
                            {item.TypeUtilisateur}
                          </span>
                        )}
                      </td>
                      <td>
                        <span className={`hm-desk-badge ${statusCls}`}>
                          <span className="badge-dot" />
                          {statusLabel}
                        </span>
                      </td>
                      <td><span className="hm-desk-addr"><MapPin size={12} />{item.Adresse || '—'}</span></td>
                      <td>{item.MagasinRetrait || '—'}</td>
                      <td><span className="hm-desk-addr"><MapPin size={12} />{item.AdresseRetreit || '—'}</span></td>
                      <td>{item.ModeLivraison || '—'}</td>
                      <td className="hm-desk-amount">{item.FraisLivraison ?? 0} MAD</td>
                      <td className="hm-desk-amount hm-desk-total">{item.TotalCommandeTTC || item.TotalCommandeHT} MAD</td>
                      <td className="hm-desk-date"><Calendar size={13} />{item.DateCommande}</td>
                      <td>
                        <div className="hm-desk-actions">
                          <Link className="hm-desk-action-btn hm-desk-view-btn" to={`/magasins/${MagasinId}/historiques/${item.IdCommande}`}>
                            <Eye size={14} /> Détails
                          </Link>
                          <Link className="hm-desk-action-btn hm-desk-move-btn" to={`/magasins/${MagasinId}/deplace/commande/${item.IdCommande}`}>
                            <ChevronRight size={14} /> Déplacer
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={11}>
                    <div className="hm-desk-empty">
                      <Package size={40} />
                      <p>{messageErros || 'Aucune commande trouvée'}</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* ── Pagination ── */}
        {pageNumbers.length > 1 && (
          <div className="hm-desk-pagination">
            <button onClick={() => handleChangePage(currentPage - 1)} disabled={currentPage === 1} className="hm-desk-page-btn">
              ← Précédente
            </button>
            {pageNumbers.map((n) => (
              <button key={n} onClick={() => handleChangePage(n)} className={`hm-desk-page-btn ${currentPage === n ? 'active' : ''}`}>
                {n}
              </button>
            ))}
            <button onClick={() => handleChangePage(currentPage + 1)} disabled={currentPage === pageNumbers.length} className="hm-desk-page-btn">
              Suivant →
            </button>
          </div>
        )}

      </div>
    </>
  );
}